import { buildAxiosInstance, buildMakeUseAxios } from "@root/api/api.tools";

const baseUrl = import.meta.env.VITE_WORKFLOW_SERVICE_URL;
export const axios = buildMakeUseAxios(baseUrl);
export const axiosV2 = buildMakeUseAxios(`${baseUrl}/v2`);
export const axiosApplyInstance = buildAxiosInstance(baseUrl);
